// material ui components
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import CloudIcon from "@mui/icons-material/Cloud";
// material ui components
//react
import "./App.css";
import { useEffect, useState } from "react"; //react
import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

//external library
import { useTranslation } from "react-i18next";
import moment from "moment";
import axios from "axios";
import "moment/min/locales";
//external library
import { createTheme, ThemeProvider } from "@mui/material";

const them = createTheme({
  typography: { fontFamily: ["ibm"] },
});
let cancelaxios = null;
const c = [
  { name: "Homs", lat: 34.73, lon: 36.71,n:1 },
  { name: "Aleppo", lat: 36.2, lon: 37.16,n:10 },
  { name: "Hama", lat: 35.1333, lon: 36.75 ,n:20},
  { name: "Damascus", lat: 33.513, lon: 36.2919 ,n:30},
  { name: "Latakia", lat: 35.51, lon: 35.78,n:40 },
  { name: "Tartous", lat: 34.88, lon: 35.88,n:50 },
  { name: "Damascus countryside", lat: 33.57, lon: 36.401,n:60 },
  { name: "Quneitra", lat: 33.12, lon: 35.82 ,n:70},
  { name: "Daraa", lat: 32.61, lon: 36.1 ,n:80},
  { name: "Sweida", lat: 32.71, lon: 36.566 ,n:90},
  { name: "Deir ez-Zor", lat: 35.333, lon: 40.15 ,n:100},
  { name: "Raqqa", lat: 35.95, lon: 39.01 ,n:110},
  { name: "Hasakah", lat: 36.511, lon: 40.7422 ,n:120},
  { name: "Idlib", lat: 35.933, lon: 36.633 ,n:130},
];
function App() {
  const [city, setcity] = useState({ name: "Homs", lat: 34.73, lon: 36.71 });
  const [age, setAge] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const handleChange = (event) => {
    setAge(event.target.value);
   let k=c.filter((d)=>{
    return d.n===event.target.value;
   })
   setcity(k[0])
   console.log(k[0])
    console.log(city)
  };

  const handleClose = () => {
    setOpen(false);
    
  };

  const handleOpen = () => {
    setOpen(true);
  };
  ///////////event
  function handlelanguge() {
    if (languge === "en") {
      i18n.changeLanguage("ar");
      setlanguge("ar");
      moment.locale("ar");
    } else {
      setlanguge("en");
      moment.locale("en");
      i18n.changeLanguage("en");
    }
    setdateandtime(moment().format("LLLL"));
  }

  ////////////event
  const { t, i18n } = useTranslation();
  const [languge, setlanguge] = useState("ar");
  const [dateandtime, setdateandtime] = useState("");
  let dir = languge === "ar" ? "rtl" : "ltr";
  const [temp, settemp] = useState({
    number: null,
    description: "",
    min: null,
    max: null,
    icon: null,
  });
  console.log("rendaring the component");
  useEffect(() => {
    i18n.changeLanguage(languge);
    moment.locale("ar");
    setdateandtime(moment().format("LLLL"));
    axios
      .get(
        `https://api.openweathermap.org/data/2.5/weather?lat=${city.lat}&lon=${city.lon}&appid=274dc2c88e06d7d880746dfdf9240b22`,
        {
          cancelToken: new axios.CancelToken((c) => {
            cancelaxios = c;
          }),
        }
      )
      .then(function (response) {
        const responsetemp = Math.round(response.data.main.temp - 273.15);
        const responsemax = Math.round(response.data.main.temp_max - 273.15);
        const responsetmin = Math.round(response.data.main.temp_min - 273.15);
        const description = response.data.weather[0].description;
        const responsicon = response.data.weather[0].icon;

        settemp({
          number: responsetemp,
          description: description,
          min: responsetmin,
          max: responsemax,
          icon: `https://openweathermap.org/img/wn/${responsicon}@2x.png`,
        });
        console.log(response.data);
      })

      .catch(function (error) {
        // handle error
        console.log(error);
      });
    return () => {
      console.log("canslling");
      cancelaxios();
    };
  }, [city]);
  return (
    <ThemeProvider theme={them}>
      <div className="App">
        <Container maxWidth="sm" style={{ width: "100%" }}>
          {/* content container  */}
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center ",
            }}
          >
            {/* card */}
            <div
              dir={dir}
              style={{
                width: "100%",
                background: "rgb(28 52 91/36%)",
                color: "white",
                borderRadius: "0px 15px",
                boxShadow: "0px  11px 1px rgba(0 ,0,0 ,0.05",
              }}
            >
              {/* content */}
              <div>
                {/* city & time */}
                <div
                  dir={dir}
                  style={{
                    padding: "10px",
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "start",
                  }}
                >
                  <Typography
                    variant="h2"
                    style={{ marginRight: "20px", fontWeight: "600" }}
                  >
                    {t(city.name)}
                  </Typography>
                  <Typography variant="h5" style={{ marginRight: "20px" }}>
                    {dateandtime}
                  </Typography>
                </div>
                {/* city & time */}
                <hr />
                {/* degree &description */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "20px",
                    width: "100%",
                  }}
                >
                  {/* tempreture */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography variant="h1" style={{ textAlign: "start" }}>
                          {temp.number}
                        </Typography>
                        <div>
                          {/* :temreture image */}
                          <img src={temp.icon}></img>
                          {/*  :temreture image */}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <div>
                          <Typography variant="h6">
                            {t(temp.description)}
                          </Typography>
                          {/* min and max */}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <h5>
                              {t("min")} :{temp.min}
                            </h5>
                            <h5 style={{ margin: "0 5px" }}>|</h5>
                            <h5>
                              {t("max")} : {temp.max}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* min and max */}
                    <div>
                      <CloudIcon
                        style={{ fontSize: "200px", color: "white" }}
                      />
                    </div>
                  </div>
                  {/* tempreture */}
                </div>
                {/* degree &description */}
              </div>
              {/* content */}
            </div>
            {/* card */}
            {/* translation container */}
            <div
              dir={dir}
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "20px",
              }}
            >
              <Button
                variant="text"
                style={{ color: "white" }}
                onClick={handlelanguge}
              >
                {languge == "en" ? "ARABIC" : "انكليزي"}
              </Button>
              <div>
                <FormControl sx={{ m: 1, minWidth: 120 }} >
                  <InputLabel id="demo-controlled-open-select-label"
                  style={{color:"white",fontSize:"15px",fontWeight:"bold"}}
                  >
                    {t("City")}
                  </InputLabel>
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={age}
                   style={{background:"#7f00ff",color:"white",fontSize:"15px",fontWeight:"bold",borderRadius:"20px 0px"}}
                    onChange={handleChange}
                  >
                    <MenuItem   value={1}>
                      <em >{t(c[0].name)}</em>
                    </MenuItem>
                    <MenuItem  value={10}>{t(c[1].name)}</MenuItem>
                    <MenuItem   value={20}>{t(c[2].name)}</MenuItem>
                    <MenuItem   value={30}>{t(c[3].name)}</MenuItem>
                    <MenuItem   value={40}>{t(c[4].name)}</MenuItem>
                    <MenuItem   value={50}>{t(c[5].name)}</MenuItem>
                    <MenuItem   value={60}>{t(c[6].name)}</MenuItem>
                    <MenuItem   value={70}>{t(c[7].name)}</MenuItem>
                    <MenuItem   value={80}>{t(c[8].name)}</MenuItem>
                    <MenuItem   value={90}>{t(c[9].name)}</MenuItem>
                    <MenuItem   value={100}>{t(c[10].name)}</MenuItem>
                    <MenuItem   value={110}>{t(c[11].name)}</MenuItem>
                    <MenuItem   value={120}>{t(c[12].name)}</MenuItem>
                    <MenuItem   value={130}>{t(c[13].name)}</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* translation container */}
          </div>
          {/* content container  */}
        </Container>
      </div>
    </ThemeProvider>
  );
}
export default App;
